// Bảng màn ⇒ mã tải lười (K6: mỗi màn 1 gói JS riêng, không nằm trong JS ban đầu). Làn mới chỉ sửa file màn của mình.
import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import type { KhoaMenu } from "../core/voApp";
import type { ManHinhProps } from "./kieuMan";

type TaiMan = () => Promise<{ default: ComponentType<ManHinhProps> }>;

export const TAI_MAN: Record<KhoaMenu, TaiMan> = {
  lop: () => import("../screens/lop/index"),
  kehoach: () => import("../screens/kehoach/index"),
  nghiday: () => import("../screens/nghiday/index"),
  tacvu: () => import("../screens/tacvu/index"),
  nguonluc: () => import("../screens/nguonluc/index"),
  thongtin: () => import("../screens/thongtin/index"),
  caidat: () => import("../screens/caidat/index"),
  "kho-ui": () => import("./KhoUi"),
};

export const MAN: Record<KhoaMenu, LazyExoticComponent<ComponentType<ManHinhProps>>> = Object.fromEntries(
  Object.entries(TAI_MAN).map(([k, f]) => [k, lazy(f)]),
) as Record<KhoaMenu, LazyExoticComponent<ComponentType<ManHinhProps>>>;

/** Tải trước mã mọi màn lúc rảnh (sau khi màn đầu đã dùng được) ⇒ bấm chuyển menu không phải chờ tải. */
export function taiTruocCacMan(tru: KhoaMenu) {
  for (const [k, f] of Object.entries(TAI_MAN)) if (k !== tru && k !== "kho-ui") void f().catch(() => {});
}
